export const COUNTRIES_IN_REGION = [
  "ID", // Indonesia
  "PH", // Philippines
  "TH", // Thailand
  "VN", //Vietnam
  "MY", // Malaysia
  "IN", // India
  "TR", // Turkey
  "BR", // Brazil
  "MX", // Mexico
  "PE", // Peru
  "CO", // Colombia
  "CL", //Chile
  "EC", // Ecuador
];

export const COUNTRIES_SUPPORT_PAYPAL = [
  "KR",
];

export const BRAINTREE = 'BRAINTREE';
export const REVENUE_CAT = 'REVENUE_CAT';
